import {
  Container,
  AccordionSection,
  AccordionItem,
  AccordionHeader,
  AccordionContent,
  ContentSection,
  Subtitle,
  PlusIcon,
  Section,
  Heading,
  GradientText
} from './style'
import { useState } from 'react'
import { PrismicRichText } from '@prismicio/react';

/**
 * @typedef {import("@prismicio/client").Content.DisignFaqSlice} DisignFaqSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<DisignFaqSlice>} DisignFaqProps
 * @param {DisignFaqProps}
 */
const DisignFaq = ({ slice }) => {

  const [openIndex, setOpenIndex] = useState(null)

  return (
    <Section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <Container>
      <ContentSection>
              <Heading><GradientText>{slice.primary.title}</GradientText></Heading>
              <Subtitle>
              <PrismicRichText
                field={slice.primary.description}
              />
              </Subtitle>
            </ContentSection>
            <AccordionSection>
              {slice.items.map((item, index) => (
                <AccordionItem key={index}>
                  <AccordionHeader onClick={() => setOpenIndex(openIndex === index ? null : index)} isOpen={openIndex === index}>
                    {item.title}
                    <PlusIcon>{openIndex === index ? '−' : '+'}</PlusIcon>
                  </AccordionHeader>
                  <AccordionContent isOpen={openIndex === index}>
                    <PrismicRichText
                      field={item.description}
                    />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </AccordionSection>
           
      </Container>
    </Section>
  );
};

export default DisignFaq;
